<template>
  <div
    id="page-login"
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <template #no-body>
          <div class="full-page-bg-color">
            <div class="vx-row no-gutter justify-center items-center">
              <div class="vx-col hidden lg:block lg:w-1/2">
                <img
                  src="@/assets/images/logo/ubunbase_login.png"
                  alt="ubun base"
                  class="responsive"
                />
              </div>
              <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                <div class="p-8">
                  <h4 class="mb-4">
                    パスワード再設定
                  </h4>
                  <ValidationForm
                    ref="resetObserver"
                    as="form"
                  >
                    <password-field
                      v-model="password"
                      name="パスワード"
                      class="mt-8"
                      rules="required|min:5|max:20"
                      full-width
                      @keydown.enter="onKeydownEnter"
                    />
                    <password-field
                      v-model="passwordConfirm"
                      class="mt-8"
                      name="パスワード（確認）"
                      rules="required|confirmed:@パスワード"
                      full-width
                      @keydown.enter="onKeydownEnter"
                    />
                    <vs-button
                      class="w-full my-8"
                      @click="onResetClick"
                    >
                      パスワードを変更
                    </vs-button>
                  </ValidationForm>
                </div>
              </div>
            </div>
          </div>
        </template>
      </vx-card>
    </div>
  </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'
import PasswordField from '@/components/fields/PasswordField'
import { UNAUTHORIZED_ERROR } from '@/user/store/errorTypes'

export default {
  name: 'Reset',
  components: {
    PasswordField
  },
  data () {
    return {
      password: '',
      passwordConfirm: ''
    }
  },
  computed: {
    ...mapState(['globalError', 'requestingStatus'])
  },
  watch: {
    globalError: {
      deep: true,
      handler ({ type, message }) {
        if (type === UNAUTHORIZED_ERROR) {
          // catchを入れておかないと以下のvue-routerエラーが出るが仕様らしい（https://stackoverflow.com/questions/62223195/vue-router-uncaught-in-promise-error-redirected-from-login-to-via-a）
          // Uncaught (in promise) Error: Redirected when going from "/password/reset/token" to "/" via a navigation guard
          this.$router.push('/').catch(() => {})
        } else {
          this.$vs.notify({
            position: 'top-center',
            color: 'danger',
            text: message,
            fixed: true
          })
        }
      }
    }
  },
  async mounted () {
    try {
      await this.checkToken(this.$route.params.token)
    } catch (e) {
      console.log(e)
    }
  },
  methods: {
    ...mapActions('auth', ['resetPassword', 'checkToken']),
    onKeydownEnter (event) {
      console.log(event)
      event.stopPropagation()
      event.preventDefault()
      // 日本語入力中のEnterキー操作は無効にする
      if (event.keyCode !== 13) return
      this.onResetClick()
    },
    async onResetClick () {
      const isValid = await this.$refs.resetObserver.validate()
      if (!isValid.valid) return
      try {
        await this.resetPassword({
          token: this.$route.params.token,
          password_confirm: this.passwordConfirm,
          password: this.password
        })
        await this.$router.push('/login')
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="scss"></style>
